import { render } from "./GetPaymentPopup.vue?vue&type=template&id=1568e5c6&scoped=true"
import script from "./GetPaymentPopup.vue?vue&type=script&lang=js"
export * from "./GetPaymentPopup.vue?vue&type=script&lang=js"

import "./GetPaymentPopup.vue?vue&type=style&index=0&id=1568e5c6&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1568e5c6"]])

export default __exports__